import jQuery from 'jquery';
import { LoggingApi } from '../../../manager-base/api/services/logging';

const loggingApi = new LoggingApi(window);

export function logJqueryMigrationErrors() {
    // do logging only if migrateWarnings is not empty. This empty warnings are creating a lot of noise in logz
    if (!jQuery.migrateWarnings || !jQuery.migrateWarnings.length) {
        return;
    }
    const migrateWarnings = jQuery.migrateWarnings.map(warning => String(warning)).join('\n');
    loggingApi.logWarningMessage(new Error(`[jquery-migrate] deprecated usages found\n${migrateWarnings}`)).catch(() => { /* do nothing */ });
    jQuery.migrateReset();
}
